import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import InstallButton from "./InstallButton";

export default function SiteFooter({ children }) {
  const { c, img } = useContent();
  return (
    <footer className="py-10 pb-28 md:pb-10 border-t border-white/5 flex flex-col items-center gap-3 text-xs font-mono-rl text-slate-500 uppercase tracking-widest" data-testid="site-footer">
      <img src={img("brand.logo_wide", "/logo-wide.png")} alt="Rally Love" className="h-8 opacity-70" />
      {c("home.footer", "© 2026 Rally Love · Piattaforma Official Paddock")}
      <div className="flex flex-wrap justify-center gap-4 normal-case tracking-normal" data-testid="footer-services">
        {[["Rally Love PRO", "/pro"], ["Rally Love PROMAX", "/promax"], ["Sponsor Activation", "/sponsor"], ["Piani e prezzi", "/pricing"], ["Accesso PROMAX", "/promax/access"], ["Rally Love Play", "/play"], ["Assistenza", "/p/assistenza"], ["Installa Rally Love", "/install"]].map(([l, to]) => <Link key={to} to={to} className="hover:text-white" data-testid={`footer-${to.replace(/\//g, "-").slice(1)}`}>{l}</Link>)}
      </div>
      <span className="normal-case tracking-normal text-[11px]">FANTARALLY utilizza esclusivamente punti virtuali. Non sono previste scommesse o vincite in denaro.</span>
      {children}
      <InstallButton />
    </footer>
  );
}
